const ANNUITY_TYPES = {
  SINGLE: 'S',
  JOINT_AND_SURVIVOR: 'J',
  PERIOD_CERTAIN: 'C',
};

export default ANNUITY_TYPES;
